import { RefinementCtx } from 'zod';
import { DateTime } from 'luxon';
import { LOCALE, ZONE } from '../../enum';
import { DateTimeOptions } from 'luxon';

export function dateTimeTransformer(
  format?: string,
  config?: {
    overwriteZone?: boolean;
    overwriteLocale?: boolean;
  },
) {
  const fromConfig: undefined | DateTimeOptions = config
    ? {
        zone: config.overwriteZone ? ZONE : undefined,
        locale: config.overwriteLocale ? LOCALE : undefined,
      }
    : undefined;

  const fromFn = format
    ? (dateString: string) =>
        DateTime.fromFormat(dateString, format, fromConfig)
    : (dateString: string) => DateTime.fromISO(dateString, fromConfig);

  return (date: string, ctx: RefinementCtx) => {
    const formattedDateTime = fromFn(date);

    if (!formattedDateTime.isValid) {
      ctx.addIssue({
        code: 'invalid_format',
        format: 'valid JS Date object',
        message: `Invalid date format: ${formattedDateTime.invalidExplanation}`,
      });
    }

    return formattedDateTime as DateTime<true>;
  };
}

export function dateToDateTimeTransformer(date: Date, ctx: RefinementCtx) {
  const formattedDateTime = DateTime.fromJSDate(date);

  if (!formattedDateTime.isValid) {
    ctx.addIssue({
      code: 'invalid_format',
      format: 'valid JS Date object',
      message: `Invalid date format: ${formattedDateTime.invalidExplanation}`,
    });
  }

  return formattedDateTime as DateTime<true>;
}
